import { formatDateShort } from '@/lib/date-format';
import { getTypeLabel } from '@/lib/constants';
import { getEventSlug } from '@/lib/event-slugs';
import type { CalendarEvent } from '@/lib/types';

interface EventListItemProps {
  event: CalendarEvent;
  lang: string;
  typeLabelFn?: (type: string) => string;
  children?: React.ReactNode;
}

export function EventListItem({ event, lang, typeLabelFn, children }: EventListItemProps) {
  const label = typeLabelFn ? typeLabelFn(event.type) : getTypeLabel(event.type, lang);
  // Down-link to the event detail page when the event is slug-mapped. Some
  // events (e.g. university-scoped) have no public slug — those stay plain text
  // rather than linking to a 404. (almanak-220z.2)
  const slug = getEventSlug(event.id);
  return (
    <div className="flex items-start gap-3 content-card p-3">
      <span className="mt-0.5 inline-block rounded bg-surface-root px-2 py-0.5 text-xs font-medium text-text-secondary">
        {formatDateShort(event.dateStart, lang)}
        {event.dateStart !== event.dateEnd && `–${formatDateShort(event.dateEnd, lang)}`}
      </span>
      <div className="flex-1">
        {slug ? (
          <a href={`/events/${slug}`} className="text-sm font-medium text-text-primary hover:underline">{event.title}</a>
        ) : (
          <span className="text-sm font-medium text-text-primary">{event.title}</span>
        )}
        <span className="ml-2 text-xs text-text-secondary">({label})</span>
        {children}
      </div>
    </div>
  );
}
